import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static targets = ["valor", "cartao", "senha", "km", "litros", "form"]
  static values = {
    type: { type: String, default: "padrao" },
    qrcode: { type: Boolean, default: false }
  }

  submit(event) {
    event.preventDefault()

    const valor = this.valorTarget.value
    if (!valor || valor === "0,00") { Swal.fire("Atenção", "Informe o valor da venda", "warning"); return }

    if (!this.qrcodeValue) {
      if (!this.cartaoTarget.value) { Swal.fire("Atenção", "Informe o número do cartão", "warning"); return }
      if (!this.senhaTarget.value) { Swal.fire("Atenção", "Informe a senha do cartão", "warning"); return }
    }

    if (this.typeValue === "combustivel") {
      if (this.hasKmTarget && !this.kmTarget.value) { Swal.fire("Atenção", "Informe a km do veículo", "warning"); return }
      if (this.hasLitrosTarget && !this.litrosTarget.value) { Swal.fire("Atenção", "Informe a quantidade de litros", "warning"); return }
    }

    const tipoProduto = this.typeValue === "combustivel" ? "COMBUSTÍVEL " : ""
    const msg = this.qrcodeValue
      ? `Confirma a venda ${tipoProduto}no valor de R$ ${valor}?`
      : `Confirma a venda ${tipoProduto}no valor de R$ ${valor} para o cartão ${this.cartaoTarget.value}?`

    Swal.fire({ title: "Confirmação", text: msg, icon: "question", showCancelButton: true, confirmButtonText: "Sim, confirmar", cancelButtonText: "Cancelar" })
      .then((result) => { if (result.isConfirmed) this.formTarget.submit() })
  }
}
